import Vuex from 'vuex';
import Vue from 'vue';
import store from '../../Modules/store/store';

Vue.use(Vuex);

const backdrop = document.getElementById('js-backdrop');

const vm = backdrop
  && new Vue({
    store,
    delimiters: ['${', '}'],
    el: '#js-backdrop',
    computed: {
      backdrop() {
        return this.$store.state.backdrop;
      },
    },

    created() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) {
          this.closeBackdrop();
        }
      });
    },

    methods: {
      closeBackdrop() {
        this.$store.dispatch('setBackdrop', false);
      },
    },
  });

export default vm;
